var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "subpage-dashboards subpage-billing-payment--dashboard" },
    [
      _c(
        "h1",
        {
          staticClass:
            "my-account__title gds-space-stack-l subpage-dashboards--left-spacer"
        },
        [_vm._v("Billing & Payment")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "my-account__payment-nav gds-flex-container gds-flex-container--left subpage-dashboards--left-spacer"
        },
        [
          _c(
            "router-link",
            {
              staticClass: "my-account__payment-nav-item",
              class: { active: _vm.subTab === "/billing" },
              attrs: { to: "/billing" }
            },
            [_vm._v("Overview")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "my-account__payment-nav-item",
              class: { active: _vm.subTab === "/report" },
              attrs: { to: "/report" }
            },
            [_vm._v("Billing Report")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "my-account__payment-nav-item",
              class: { active: _vm.subTab === "/preferences" },
              attrs: { to: "/preferences" }
            },
            [_vm._v("Billing Preferences")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "my-account__payment-nav-item",
              class: { active: _vm.subTab === "/saved-payments" },
              attrs: { to: "/saved-payments" }
            },
            [_vm._v("Saved Payments")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }